import { Capacitor } from '@capacitor/core';

import { MATOMO_CONFIG } from '@/constants';

/**
 * Gets the platform name for Matomo tracking.
 * @returns Platform name: 'iOS', 'Android', or 'PWAOnly'.
 */
function getPlatform(): string {
  switch (Capacitor.getPlatform()) {
    case 'ios':
      return 'iOS';
    case 'android':
      return 'Android';
    default:
      return 'PWAOnly';
  }
}

/**
 * Retrieves or generates a unique Matomo visitor ID.
 * Persists it in localStorage.
 * @returns A hexadecimal visitor ID string.
 */
export function getVisitorId(): string {
  let visitorId: string = '';
  try {
    const oldId = localStorage.getItem('mtm_VisitorId');
    if (oldId) {
      visitorId = oldId;
      return visitorId;
    }

    // generate a hexadecimal string with configured length
    const newId = Array.from({ length: MATOMO_CONFIG.VISITOR_ID_LENGTH }, () =>
      Math.floor(Math.random() * 16).toString(16),
    ).join('');
    localStorage.setItem('mtm_VisitorId', newId);
    visitorId = newId;
  } catch (error) {
    console.error('[Matomo helper] error while getting visitor ID: ' + error);
  }
  return visitorId;
}

/**
 * Gets the platform name for Matomo tracking.
 * @returns Platform name: 'iOS', 'Android', or 'PWAOnly'.
 */
export function getPlatformName(): string {
  return getPlatform();
}
